function Controller($filter, BusComponent, PageHeading, Toast) {
	'ngInject';

	const vm = this;
	vm.fetchBusesByDate = fetchBusesByDate;
	vm.getBuses = BusComponent.getBuses;

	activate();

	function activate() {
		const heading = $filter('translate')('SIDEBAR.WAYBILL');
		const title = `BTMS | ${$filter('translate')('SIDEBAR.WAYBILL')}`;

		PageHeading.setPageHeading(heading, title);
		BusComponent.clearBuses();
	}

	function fetchBusesByDate(date) {
		BusComponent.fetchWaibillByDate(date)
			.then(function(res) {
				if (res.data && res.data.errors) {
					Toast.responseError(res.data.errors);
				} else if (!res.length) {
					Toast.error($filter('translate')('NOT_FOUND.BUSES_BY_DATE'));
				}
			});
	}
}

export default Controller;



/** WEBPACK FOOTER **
 ** ./client/private/waybill/choose-bus/choose-bus.controller.js
 **/